module.exports = __webpack_public_path__ + "static/media/Logo.38c0bfd8.png";